import React, {useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {
  ActionWrapper,
  Wrapper,
} from './styles';
import FlightReceipt from '../../components/ReceiptCard/FlightReceipt';
import RoadReceipt from '../../components/ReceiptCard/RoadReceipt';
import WaterReceipt from '../../components/ReceiptCard/WaterReceipt';
import TrainReceipt from '../../components/ReceiptCard/TrainReceipt';
import {Button, Drawer} from "antd";
import BookingFeedback from "../../components/BookingFeedback";
import FeedbackForm from "../../components/FeedbackForm";
import {StyledButton} from "../../components/CustomAntdComponents/StyledButton";
import {useFlightSearchStore} from "../../store/flightSearch/flightSearchStore";
import {useRoadSearchStore} from "../../store/roadSearch/roadSearchStore";
import {useBookingStore} from "../../store/booking/bookingStore";
import {useAuthStore} from "../../store/auth/authStore";
import SaveDetailsModal from "../../components/BookingSuccess/SaveDetailsModal";
import Done from '../../components/FeedbackForm/Done';
import { redirectHome } from '../../utils/navigation';
import { submitFeedbackToGoogleSheet } from '../../utils/feedback';
import { FeedbackFormData } from '../../components/FeedbackForm';

function PaymentReceipt() {
  const { tripType } = useParams();
  const navigate =  useNavigate();
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [feedbackDrawer, setOpenFeedbackDrawer] = useState<boolean>(false);
  const [openFeedbackDone, setOpenFeedbackDone] = useState<boolean>(false);
  const [openSaveDetails, setOpenSaveDetails] = useState<boolean>(false);
  const [reaction, setReaction] = useState("");
  const [feedbackFormData, setFeedbackFormData] = useState<FeedbackFormData>({
    positiveFeedback: ['Prices were fair'],
    improvementAreas: ['Loading time'],
    comment: '',
  });
  const { isLoggedIn } = useAuthStore();
    const {
        resetFormData,
    } = useFlightSearchStore();
    const {
        resetFormData: resetRoadSearchData
    } = useRoadSearchStore();

    const {
        resetBooking,
    } = useBookingStore();

  const redirectToSearch = () => {
      resetBooking();

      if(tripType === 'flight') {
          resetFormData();
      }

      if(tripType === 'road') {
          resetRoadSearchData();
      }
      navigate(`/search/${tripType}`);
  }

  const handleFeedbackExit = () => {
    setOpenDrawer(false);
    setOpenFeedbackDrawer(false);
    setOpenFeedbackDone(false);
    if (!isLoggedIn) {
      setOpenSaveDetails(true);
    } else {
      redirectHome();
    }
  };

  const handleFeedbackSubmit = () => {
    const flightBookingContact = useFlightSearchStore.getState().bookingContact;
    const roadBookingContact = useRoadSearchStore.getState().bookingContact;
    const bookingContact = tripType === 'flight' ? flightBookingContact : roadBookingContact;
    const userEmail = bookingContact?.email || useAuthStore.getState().b2CUser?.Email || '';
    const bookingStoreState = useBookingStore.getState();
    const bookingReference = 
      (bookingStoreState?.flightReservation as any)?.BookingReferenceId ||
      (bookingStoreState?.roadReservation as any)?.BookingReferenceId ||
      (bookingStoreState?.confirmData as any)?.[0]?.BookingReferenceId ||
      (bookingStoreState?.bookingPayload as any)?.BookingReference ||
      '';

    submitFeedbackToGoogleSheet({
      rating: reaction,
      positiveFeedback: feedbackFormData.positiveFeedback,
      improvementAreas: feedbackFormData.improvementAreas,
      comment: feedbackFormData.comment,
      bookingReference,
      userEmail,
    });

    setOpenFeedbackDrawer(false);
    setOpenFeedbackDone(true);
  };

  const FeedbackFooter = (
    <StyledButton mode="default" block onClick={handleFeedbackExit}>
      Not now
    </StyledButton>
  );

  const FeedbackFormFooter = (
      <StyledButton mode="primary" block onClick={handleFeedbackSubmit}>
        Submit feedback
      </StyledButton>
  )

  const FeedbackDoneFooter = (
        <StyledButton mode="primary" block onClick={handleFeedbackExit}>
            Done
        </StyledButton>
  )

  return (
    <>
      <div className="container">
        <Wrapper>
          { tripType === 'flight' && <FlightReceipt />}
          { tripType === 'road' && <RoadReceipt />}
          { tripType === 'water' && <WaterReceipt />}
          { tripType === 'rail' && <TrainReceipt />}
        </Wrapper>

        <ActionWrapper>
          <Button type="primary" block onClick={() => setOpenDrawer(true)}>
            Done
          </Button>
        </ActionWrapper>

        <SaveDetailsModal 
          open={openSaveDetails} 
          onClose={() => {
            setOpenSaveDetails(false);
             redirectHome();
          }} 
        />

        <Drawer
            placement={"bottom"}
            onClose={handleFeedbackExit}
            open={openDrawer}
            footer={FeedbackFooter}
            height="auto"
            getContainer={document.getElementById('app-container') as HTMLElement}
        >
         <BookingFeedback openFeedbackForm={(reaction) => {
              setOpenDrawer(false);
              setOpenFeedbackDrawer(true);
              setReaction(reaction);
         }} hideAction />
        </Drawer>

        <Drawer
            title="Feedback"
            placement={"bottom"}
            onClose={handleFeedbackExit}
            open={feedbackDrawer}
            footer={FeedbackFormFooter}
            height="100%"
            getContainer={document.getElementById('app-container') as HTMLElement}
            bodyStyle={{ paddingBottom: '100px' }}
        >
          <FeedbackForm 
            reaction={reaction} 
            feedbackData={feedbackFormData}
            onChange={setFeedbackFormData}
          />
        </Drawer>

        <Drawer
            placement={"bottom"}
            height="auto"
            onClose={handleFeedbackExit}
            open={openFeedbackDone}
            footer={FeedbackDoneFooter}
            getContainer={document.getElementById('app-container') as HTMLElement}
        >
             <Done />
        </Drawer>
      </div>
    </>
  );
}

export default PaymentReceipt;
